import React from 'react';
import { Control, Controller } from 'react-hook-form';
import { EditableQuestion } from '../../../../../types';
import { StyledQuestionFieldContainer } from '../styles';
import Switch from '../../../../../../Shared/Switch';

interface Props {
  control: Control<EditableQuestion>;
  /** True where the question collects nothing, so requiring an answer could never be met. */
  isNeverRequired?: boolean;
}

const RequiredEditor = ({ control, isNeverRequired = false }: Props) => (
  <Controller
    control={control}
    name="required"
    render={({ field: { ref, ...field } }) => (
      <StyledQuestionFieldContainer>
        <Switch
          label="Is required"
          {...field}
          checked={field.value}
          disabled={isNeverRequired}
          reverseOrder={false}
        />
      </StyledQuestionFieldContainer>
    )}
  />
);

export default RequiredEditor;
